var map = {
	"./video-carousel.de-CH.json": 1501,
	"./video-carousel.de-DE.json": 1502,
	"./video-carousel.en-CA.json": 1503,
	"./video-carousel.en-GB.json": 1504,
	"./video-carousel.en-IN.json": 1505,
	"./video-carousel.en-ME.json": 1506,
	"./video-carousel.en-US.json": 1507,
	"./video-carousel.es-EM.json": 1508,
	"./video-carousel.es-ES.json": 1509,
	"./video-carousel.fr-BE.json": 1510,
	"./video-carousel.fr-CA.json": 1511,
	"./video-carousel.fr-CH.json": 1512,
	"./video-carousel.nl-BE.json": 1513,
	"./video-carousel.nl-NL.json": 1514,
	"./video-carousel.pl-PL.json": 1515,
	"./video-carousel.pt-BR.json": 1516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1500;